{"xs":"0em","sm":"22.5em","md":"37.5em","lg":"60em","xl":"85.375em"}